module.exports = __webpack_public_path__ + "img/4.9f9f8ab2.jpg";